import { Box, Flex, Text, CloseButton } from "@chakra-ui/react";
import { customerDashboardStyles } from "theme/overrides/customer";
import { useState, useEffect } from "react";
import { CallToActionBanner } from "./CallToActionBanner";

interface DashboardHeaderProps {
  user: any;
  onPlaceOrder: () => void;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  user,
  onPlaceOrder,
}) => {
  const [showWelcome, setShowWelcome] = useState(false);

  useEffect(() => {
    const welcomeShown = sessionStorage.getItem('welcomeMessageShown');
    if (!welcomeShown) {
      setShowWelcome(true);
      sessionStorage.setItem('welcomeMessageShown', 'true');
    }
  }, []);

  const handleDismissWelcome = () => {
    setShowWelcome(false);
  };

  return (
    <>
      {showWelcome && (
        <Box
          bg={customerDashboardStyles.welcome.bg}
          borderRadius={customerDashboardStyles.welcome.borderRadius}
          px={{ base: "16px", md: "24px" }}
          py={{ base: "10px", md: "12px" }}
          mb="16px"
        >
          <Flex alignItems="center" justifyContent="space-between">
            <Text fontSize="14px">
              Welcome back{user?.first_name ? `, ${user.first_name}` : ""}!
            </Text>
            <CloseButton
              size="sm"
              onClick={handleDismissWelcome}
              ml="8px"
              _hover={{ bg: "rgba(0,0,0,0.05)" }}
            />
          </Flex>
        </Box>
      )}

      <CallToActionBanner onPlaceOrder={onPlaceOrder} />
    </>
  );
};

export default DashboardHeader;
